import script from "./MazdaAll.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaAll.vue?vue&type=script&setup=true&lang=js"

import "./MazdaAll.vue?vue&type=style&index=0&id=1a749b73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a749b73"]])

export default __exports__